<template>
  <div ref="mainSection" class="relative overflow-hidden h-screen bg-[#080808] w-full font-['Formula1-Regular']">

    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95%] max-w-5xl h-[75vh]">
      
      <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
  
    <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
      <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Big 2 Overall Leaderboard</h2>
      <i class="fas fa-trophy text-gray-400 text-xl"></i>
    </div>

    <div class="flex-1 overflow-y-auto w-full bg-white relative">
      <table class="w-full text-left border-collapse">
        
        <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
          <tr>
            <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
            <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
            <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-center">Average Position</th>
            <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Form</th>
          </tr>
        </thead>
        
        <tbody>
          <tr v-for="(player, index) in playerSortedAveragePosition" 
              :key="player.name" 
              :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
            
            <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
            <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
            <td class="px-6 py-4 text-center text-gray-700 font-mono">{{ player.averageFinishingPosition }}</td>
            
            <td class="px-6 py-4 text-right">
              <div class="flex items-center justify-end gap-2 font-mono">
                <span v-if="getPlayerForm(player.name, player.averageFinishingPosition) < 0" class="text-green-600 font-medium">
                  <i class="fas fa-arrow-up"></i> {{ getPlayerForm(player.name, player.averageFinishingPosition) }}
                </span>
                <span v-else-if="getPlayerForm(player.name, player.averageFinishingPosition) > 0" class="text-red-600 font-medium">
                  <i class="fas fa-arrow-down"></i> +{{ getPlayerForm(player.name, player.averageFinishingPosition) }}
                </span>
                <span v-else class="text-gray-400">
                  -
                </span>
              </div>
            </td>
            
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
  
  <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
    <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Win Percentage</h2>
    <i class="fas fa-medal text-gray-400 text-xl"></i>
  </div>

  <div class="flex-1 overflow-y-auto w-full bg-white relative">
    <table class="w-full text-left border-collapse">
      
      <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
        <tr>
          <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
          <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
          <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Win Percentage</th>
        </tr>
      </thead>
      
      <tbody>
        <tr v-for="(player, index) in playerSortedWinPercentage" 
            :key="player.name" 
            :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
          
          <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
          <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
          
          <td class="px-6 py-4 text-right">
            <div class="font-mono text-gray-800 font-medium">{{ player.winPercentage }}%</div>
            <div class="text-xs text-gray-400 font-mono mt-0.5">({{ player.wins }}/{{ player.gamesPlayed }})</div>
          </td>
          
        </tr>
      </tbody>
    </table>
  </div>
</div>

      <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
        <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
          <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Second Percentage</h2>
          <i class="fas fa-medal text-gray-400 text-xl"></i>
        </div>
        <div class="flex-1 overflow-y-auto w-full bg-white relative">
          <table class="w-full text-left border-collapse">
            <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
              <tr>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Second Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(player, index) in playerSortedSecondPercentage" 
                  :key="player.name" 
                  :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
                <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
                <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
                <td class="px-6 py-4 text-right">
                  <div class="font-mono text-gray-800 font-medium">{{ player.secondPercentage }}%</div>
                  <div class="text-xs text-gray-400 font-mono mt-0.5">({{ player.seconds }}/{{ player.gamesPlayed }})</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
        <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
          <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Third Percentage</h2>
          <i class="fas fa-award text-gray-400 text-xl"></i>
        </div>
        <div class="flex-1 overflow-y-auto w-full bg-white relative">
          <table class="w-full text-left border-collapse">
            <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
              <tr>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Third Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(player, index) in playerSortedThirdPercentage" 
                  :key="player.name" 
                  :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
                <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
                <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
                <td class="px-6 py-4 text-right">
                  <div class="font-mono text-gray-800 font-medium">{{ player.thirdPercentage }}%</div>
                  <div class="text-xs text-gray-400 font-mono mt-0.5">({{ player.thirds }}/{{ player.gamesPlayed }})</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
        <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
          <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Loss Percentage</h2>
          <i class="fas fa-times-circle text-gray-400 text-xl"></i>
        </div>
        <div class="flex-1 overflow-y-auto w-full bg-white relative">
          <table class="w-full text-left border-collapse">
            <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
              <tr>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Loss Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(player, index) in playerSortedLossPercentage" 
                  :key="player.name" 
                  :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
                <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
                <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
                <td class="px-6 py-4 text-right">
                  <div class="font-mono text-gray-800 font-medium">{{ player.lossPercentage }}%</div>
                  <div class="text-xs text-gray-400 font-mono mt-0.5">({{ player.losses }}/{{ player.gamesPlayed }})</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card absolute inset-0 bg-white rounded-2xl shadow-2xl border border-gray-300 flex flex-col overflow-hidden">
        <div class="px-6 py-4 border-b-2 border-gray-200 bg-gray-100 flex justify-between items-center shrink-0">
          <h2 class="text-xl text-[#FF0000] font-['Formula1-Bold'] m-0">Unique Days In The Lead</h2>
          <i class="fas fa-calendar-check text-gray-400 text-xl"></i>
        </div>
        <div class="flex-1 overflow-y-auto w-full bg-white relative">
          <table class="w-full text-left border-collapse">
            <thead class="sticky top-0 z-10 bg-gray-50 shadow-sm outline outline-1 outline-gray-200">
              <tr>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Pos</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider">Player</th>
                <th class="px-6 py-4 text-sm text-gray-500 font-['Formula1-Bold'] uppercase tracking-wider text-right">Days</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(player, index) in sortedLowestAverageCounts" 
                  :key="player.name" 
                  :class="[getRowClass(index), 'hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0']">
                <td class="px-6 py-4 font-['Formula1-Bold'] text-gray-700">{{ index + 1 }}</td>
                <td class="px-6 py-4 text-gray-900">{{ player.name }}</td>
                <td class="px-6 py-4 text-right font-mono text-gray-800 font-medium">
                  {{ player.days }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ref } from 'vue';  // Import ref from 'vue'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  name: 'HomePage',
  props: {
    msg: String
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);

    // Grab all cards
    const cards = gsap.utils.toArray(this.$el.querySelectorAll('.card'));
    const totalCards = cards.length;
    
    if (!totalCards) return;

    const yOffset = 32;
    const scaleStep = 0.05;

    // Initial setup: Stack them properly
    cards.forEach((card, i) => {
      gsap.set(card, {
        y: -i * yOffset,
        scale: 1 - (i * scaleStep),
        zIndex: totalCards - i, // Card 0 gets highest z-index
      });
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.mainSection,
        start: "top top",
        // Total scroll distance. Adjust this to make the scrolling faster or slower
        end: `+=${totalCards * 120}%`, 
        pin: true,
        scrub: 1, 
      },
    });

    // Loop through every card to cycle the whole deck
    for (let i = 0; i < totalCards; i++) {
      const label = `shuffle-${i}`;
      const durationOut = 0.4; // Time to slide right
      const durationIn = 0.4;  // Time to slide to the back
      const totalDuration = durationOut + durationIn;

      // 1. Top card slides out to the right and slightly down
      tl.to(cards[i], {
        x: "110%", // Slide completely off the deck to the right
        y: 50,     
        rotation: 12,
        ease: "power1.in",
        duration: durationOut
      }, label);

      // 2. Snap the z-index so it drops behind the deck
      tl.set(cards[i], {
        zIndex: -i - 1 
      }, `${label}+=${durationOut}`);

      // 3. Slide the card back into the "back" of the stack
      const backPos = totalCards - 1;
      tl.to(cards[i], {
        x: 0,
        y: -backPos * yOffset,
        scale: 1 - (backPos * scaleStep),
        rotation: 0,
        ease: "power1.out",
        duration: durationIn
      }, `${label}+=${durationOut}`);

      // 4. Simultaneously slide all OTHER cards forward to fill the gap
      cards.forEach((card, index) => {
        if (index === i) return; // Skip the active card we are already animating

        let currentPos;
        // Calculate where this card currently is in the visual stack
        if (index > i) {
          currentPos = index - i; // Cards that haven't been shuffled yet
        } else {
          currentPos = totalCards - i + index; // Cards that are already at the back
        }

        const nextPos = currentPos - 1; // Move one step to the front

        tl.to(card, {
          y: -nextPos * yOffset,
          scale: 1 - (nextPos * scaleStep),
          ease: "power1.inOut",
          duration: totalDuration
        }, label);
      });
    }
  },
  beforeUnmount() {
    // Clean up GSAP instances when navigating away
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  },
  data() {
    return {
      apiData: [], // To store the API response
      playerStatisticsData: [],
      selectedPlayer: '', //store selected player from dropdown box
      playerSortedWins: [],
      playerSortedSeconds: [],
      playerSortedThirds: [],
      playerSortedLosses: [],
      playerSortedGamesPlayed: [],
      playerSortedWinPercentage: [],
      playerSortedSecondPercentage: [],
      playerSortedThirdPercentage: [],
      playerSortedLossPercentage: [],
      playerSortedAveragePosition: [],
      sortedLowestAverageCounts: [], // Number of days each player had the lowest average
      isOpen: ref([false, false, false, false, false, false, false, false, false, false]), // Use Vue 3's ref
    };
  },
  computed: {
    playerOptions() {
      // Use a Set to automatically remove duplicates
      const playersSet = new Set();

      // Extract player names from apiData.players
      this.apiData.forEach(dataItem => {
        dataItem.players.forEach(player => {
          playersSet.add(player);
        });
      });

      // Convert the Set back to an array and sort it
      const players = Array.from(playersSet).sort();

      return players;
    },
  },
  methods: {
    getLatestRecord(playerName, apiData) {
      // Filter records for the specific player
      const playerRecords = apiData.filter(record => record.player === playerName);

      // Sort the records by the 'created_at' property in descending order
      playerRecords.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      // Return the latest record or null if no records are found
      return playerRecords.length > 0 ? playerRecords[0] : null;
    },

    getRowClass(index) {
      switch (index) {
        case 0:
          return 'first-row';
        case 1:
          return 'second-row';
        case 2:
          return 'third-row';
        default:
          return '';
      }
    },

    toggle(index) {
      this.isOpen[index] = !this.isOpen[index]; // Directly mutate reactive array
    },

    calculatePlayerStats(apiData) {
      //store wins, seconds, thirds, and losses for each player in array
      const winningCounts = {};
      const secondCounts = {};
      const thirdCounts = {};
      const losingCounts = {};
      const gamesPlayedCounts = {};

      // Count how many times each player has won and lost
      apiData.forEach(dataItem => {
        if (dataItem.winner) {
          if (winningCounts[dataItem.winner]) {
            winningCounts[dataItem.winner]++;
          } else {
            winningCounts[dataItem.winner] = 1;
          }
        }

        if (dataItem.second) {
          if (secondCounts[dataItem.second]) {
            secondCounts[dataItem.second]++;
          } else {
            secondCounts[dataItem.second] = 1;
          }
        }

        if (dataItem.third) {
          if (thirdCounts[dataItem.third]) {
            thirdCounts[dataItem.third]++;
          } else {
            thirdCounts[dataItem.third] = 1;
          }
        }

        if (dataItem.loser) {
          if (losingCounts[dataItem.loser]) {
            losingCounts[dataItem.loser]++;
          } else {
            losingCounts[dataItem.loser] = 1;
          }
        }
      });

      // Now, count the games played for each player
      apiData.forEach(dataItem => {
        dataItem.players.forEach(player => {
          if (gamesPlayedCounts[player]) {
            gamesPlayedCounts[player]++;
          } else {
            gamesPlayedCounts[player] = 1;
          }
        });
      });

      // Create an array of player objects with wins and losses
      const playersWithStats = Object.keys(gamesPlayedCounts).map(player => {
        const wins = winningCounts[player] || 0;
        const seconds = secondCounts[player] || 0;
        const thirds = thirdCounts[player] || 0;
        const losses = losingCounts[player] || 0;
        const gamesPlayed = gamesPlayedCounts[player] || 0;

        // Calculate total points based on finishing positions
        const totalPoints = wins * 1 + seconds * 2 + thirds * 3 + losses * 4;

        // Calculate average finishing position
        const averageFinishingPosition = (totalPoints / gamesPlayed).toFixed(3);

        // Calculate win and loss percentages
        const winPercentage = ((wins / gamesPlayed) * 100).toFixed(2); // Rounds to 2 decimal points
        const secondPercentage = ((seconds / gamesPlayed) * 100).toFixed(2); // Rounds to 2 decimal points
        const thirdPercentage = ((thirds / gamesPlayed) * 100).toFixed(2); // Rounds to 2 decimal points
        const lossPercentage = ((losses / gamesPlayed) * 100).toFixed(2); 
        const gamePercentage = ((gamesPlayed / this.apiData.length) * 100).toFixed(2);
        

        return {
          name: player,
          wins,
          seconds,
          thirds,
          losses,
          gamesPlayed,
          gamePercentage,
          winPercentage,
          secondPercentage,
          thirdPercentage,
          lossPercentage,
          averageFinishingPosition,
        };
      });

      // Sort the players by the number of wins in descending order
      this.playerSortedWins = playersWithStats.slice().sort((a, b) => b.wins - a.wins);

      // Sort the players by the number of seconds in descending order
      this.playerSortedSeconds = playersWithStats.slice().sort((a, b) => b.seconds - a.seconds);

      // Sort the players by the number of thirds in descending order
      this.playerSortedThirds = playersWithStats.slice().sort((a, b) => b.thirds - a.thirds);

      // Sort the players by the number of losses in descending order
      this.playerSortedLosses = playersWithStats.slice().sort((a, b) => b.losses - a.losses);

      // Sort the players by the number of games played in descending order
      this.playerSortedGamesPlayed = playersWithStats.slice().sort((a, b) => b.gamesPlayed - a.gamesPlayed);

      // Sort the players by winPercentage in descending order
      this.playerSortedWinPercentage = playersWithStats.slice().sort((a, b) => b.winPercentage - a.winPercentage);

      // Sort the players by secondPercentage in descending order
      this.playerSortedSecondPercentage = playersWithStats.slice().sort((a, b) => b.secondPercentage - a.secondPercentage);

      // Sort the players by thirdPercentage in descending order
      this.playerSortedThirdPercentage = playersWithStats.slice().sort((a, b) => b.thirdPercentage - a.thirdPercentage);

      // Sort the players by lossPercentage in descending order (although I could do it ascending instead)
      this.playerSortedLossPercentage = playersWithStats.slice().sort((a, b) => b.lossPercentage - a.lossPercentage);

      // Sort the players by average finshing position in ascending order
      this.playerSortedAveragePosition = playersWithStats.slice().sort((a, b) => a.averageFinishingPosition - b.averageFinishingPosition);

      return playersWithStats;
    },

    getPlayerForm(playerName, playerTodayAverage) {
      // else if player1 selected, return wins, seconds, thirds, losses
      const yesterdayRecord = this.getLatestRecord(playerName, this.playerStatisticsData);

      if (yesterdayRecord) {
        const form = (playerTodayAverage - yesterdayRecord.averageFinishingPosition).toFixed(3);

        // return score difference from todays average & yesterdays average
        return form
      }
      else {
        return 0.00;
      }
    },

    processPlayerStatisticsData() {
      // 1. Get a list of all unique dates where a game was played using your raw game logs (apiData)
      const activeDates = [...new Set(this.apiData.map(game => game.created_at.split('T')[0]))];
      
      const lowestAverageCounts = {};

      // 2. Loop through only the active game days
      activeDates.forEach(date => {
        // Look at the state of the leaderboard at the very end of this active day
        const endOfDay = date + 'T23:59:59'; 
        
        // Filter out any averages from the future
        const pastStats = this.playerStatisticsData.filter(stat => stat.created_at <= endOfDay);
        
        // 3. Find every player's most recent average up to this specific day
        const latestStatsUpToDay = {};
        pastStats.forEach(stat => {
          if (!latestStatsUpToDay[stat.player] || stat.created_at > latestStatsUpToDay[stat.player].created_at) {
            latestStatsUpToDay[stat.player] = stat;
          }
        });

        // 4. Compare all players to find the true overall leader for this day
        let dailyLeader = null;
        let lowestAverage = Infinity;

        Object.values(latestStatsUpToDay).forEach(stat => {
          if (stat.averageFinishingPosition < lowestAverage) {
            lowestAverage = stat.averageFinishingPosition;
            dailyLeader = stat.player;
          }
        });

        // 5. Award 1 point to the true leader of that active day
        if (dailyLeader) {
          if (!lowestAverageCounts[dailyLeader]) {
            lowestAverageCounts[dailyLeader] = 0;
          }
          lowestAverageCounts[dailyLeader]++;
        }
      });

      // 6. Convert the totals into a sorted array for your Vue table
      const sortedLowestAverageCounts = Object.entries(lowestAverageCounts)
        .sort((a, b) => b[1] - a[1]) // Sort highest to lowest
        .map(([name, days]) => ({ name, days })); 

      this.sortedLowestAverageCounts = sortedLowestAverageCounts;
    },
  },
  created() {
  document.title = 'Big 2 Stats'; // Set the new tab title
  // Make a GET request to the API
  axios.get('https://kbcardgames.xyz/api/big2-statistics/')
    .then(response => {
      // Handle the successful response
      this.apiData = response.data;

      // Calculate the top 3 winning players
      const playerStats = this.calculatePlayerStats(this.apiData);


      axios.post('https://kbcardgames.xyz/api/receive-data/', { playerStats })
        .then(response => {
          console.log('Player stats sent successfully:', response.data);
        })
        .catch(error => {
          console.error('Error sending player stats:', error.response.data);
        });
    })
    .catch(error => {
      // Handle any errors
      console.error('Error:', error);
    });

    axios.get('https://kbcardgames.xyz/api/player-statistics/')
      .then(response => {
        // Handle the successful response
        this.playerStatisticsData = response.data;

        // Check if apiData is already loaded. If it is, run the math!
        if (this.apiData.length > 0) {
           this.processPlayerStatisticsData(); 
        }

        // Log success to the console
        console.log('playerStatisticsData API request successful:', response);
      })
      .catch(error => {
        // Handle any errors
        console.error('Error:', error);
      });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: 'Formula1-Regular';
  src: url('@/assets/fonts/Formula1-Regular.otf') format('opentype'); /* IE9 Compat Modes */
}

@font-face {
  font-family: 'Formula1-Bold';
  src: url('@/assets/fonts/Formula1-Bold.otf') format('opentype'); /* IE9 Compat Modes */
}

h3{
  font-family: 'Formula1-Bold', sans-serif;
  margin-top: 15px;
}

.apiLength{
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 13px;
  margin-top: -10px;
}

.playerAverageFinishingPosition{
  margin-top: 20px;
  margin-bottom: 30px;
}

.playerAverageFinishingPosition th{
  border: none;
}

.playerAverageFinishingPosition td{
  border: none;
}

/* Style even rows after the third one */
.playerAverageFinishingPosition tr:nth-child(n+4):nth-child(even) {
  background-color: #ffffff; /* or simply background-color: white; */
}

/* Style odd rows after the third one */
.playerAverageFinishingPosition tr:nth-child(n+4):nth-child(odd) {
  background-color: #f1f1f1;
}

.playerAverageFinishingPosition td:nth-child(2) {
  width: 90px;
}

.playerAverageFinishingPosition td:nth-child(1) {
  font-weight: bold;
}

.playerAverageFinishingPosition td:last-child {
  width: 75px; /* Adjust this value to make the column smaller */
  text-align: center; /* Center-align the content if desired */
}

.first-row {
  background-color: #ffd700; /* Gold color */
}
.second-row {
  background-color: #c0c0c0 ; /* Silver color */
}
.third-row {
  background-color: #cd7f32; /* Bronze color */
}

.collapsible {
  background-color: #FF0000;
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: center;
  outline: none;
  font-size: 15px;
  margin-bottom: 20px; /* Add margin at the bottom of each collapsible button */
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 15px;
  
}

.collapsible i {
  position: absolute; /* Absolute positioning for the icon */
  right: 50px;
  font-size: 15px; /* Adjust icon size as needed */
  transition: background-color 0.3s ease;
}

.active, .collapsible:hover {
  background-color: #b10000;
}

.content {
  padding: 0 10px;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: scaleY(0.95);
  transform-origin: top;
  transition: 
    max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
}

.content.open {
  max-height: 1000px;
  opacity: 1;
  transform: scaleY(1);
}

.playerGamesPlayed,
.playerWins,
.playerSeconds,
.playerThirds,
.playerLosses,
.playerDaysInTheLead,
.playerWinPercentage,
.playerLossPercentage,
.playerSecondPercentage,
.playerThirdPercentage{
  margin-bottom: 60px;
}

/* Style for tables */
table {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #dcdcdc;
}

/* Style for table headers */
th {
  background-color: #FF0000;
  color: white; /* Set font color to white */
  border: none;
  padding: 8px;
  text-align: center;
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 15px;
}

/* Style for table cells */
td {
  border: none;
  padding: 8px;
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 13px;
  color: black;
}

td i {
  position: absolute; /* Absolute positioning for the icon */
  right: 78px;
  margin-top: 2px;
}

.playerGamesPlayed tr:nth-child(even),
.playerWins tr:nth-child(even),
.playerSeconds tr:nth-child(even),
.playerThirds tr:nth-child(even),
.playerLosses tr:nth-child(even),
.playerDaysInTheLead tr:nth-child(even),
.playerWinPercentage tr:nth-child(even),
.playerLossPercentage tr:nth-child(even),
.playerSecondPercentage tr:nth-child(even),
.playerThirdPercentage tr:nth-child(even) {
  background-color: #ffffff; /* or simply background-color: white; */
}

.playerGamesPlayed tr:nth-child(odd),
.playerWins tr:nth-child(odd),
.playerSeconds tr:nth-child(odd),
.playerThirds tr:nth-child(odd),
.playerLosses tr:nth-child(odd),
.playerDaysInTheLead tr:nth-child(odd),
.playerWinPercentage tr:nth-child(odd),
.playerLossPercentage tr:nth-child(odd),
.playerSecondPercentage tr:nth-child(odd),
.playerThirdPercentage tr:nth-child(odd) {
  background-color: #f1f1f1;
}

.playerWins td:last-child,
.playerSeconds td:last-child,
.playerThirds td:last-child,
.playerLosses td:last-child,
.playerDaysInTheLead td:last-child,
.playerGamesPlayed td:last-child,
.playerWinPercentage td:last-child,
.playerLossPercentage td:last-child,
.playerSecondPercentage td:last-child,
.playerThirdPercentage td:last-child{
  width: 125px;
}

.playerWins td:first-child,
.playerSeconds td:first-child,
.playerThirds td:first-child,
.playerLosses td:first-child,
.playerDaysInTheLead td:first-child,
.playerGamesPlayed td:first-child,
.playerWinPercentage td:first-child,
.playerLossPercentage td:first-child,
.playerSecondPercentage td:first-child,
.playerThirdPercentage td:first-child {
  font-weight: bold;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
  width: 200px; /* Adjust the width as needed */
  margin-top: 20px;
}

.card {
  will-change: transform;
}
</style>